import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';

/**
 * Estado do modal de oferta de notificação. O caso é revalidado em segundo plano e pode deixar
 * de ser elegível com o modal aberto (atendimento assumido, notificação gerada em outra aba).
 * Derivar `aberto && elegível` fecharia o modal, mas o estado seguiria `true` e ele reabriria
 * sem clique quando a elegibilidade voltasse — por isso o estado é ajustado no render.
 */
export function useModalOfertaNotificacao(isElegivel) {
  const $ = _c(2);
  const [isAberto, setIsAberto] = useState(false);
  if (isAberto && !isElegivel) {
    setIsAberto(false);
  }
  let t0;
  if ($[0] !== isAberto) {
    t0 = {
      isAberto,
      setIsAberto
    };
    $[0] = isAberto;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}